import { Button, Form, Input, Modal } from 'antd';
import React, { useState } from 'react';
import { addPartner } from '../../services/api/cashless-vaccination';
import { message } from 'antd';

function AddPartnerModal(props) {
  console.log(props, '[props]');
  const [partnerName, setPartnerName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    setPartnerName(e.target.value);
  };

  const handleSubmit = () => {
    console.log('Partner Name:', partnerName);
    if (!partnerName) {
      message.error('Partner Name is missing');
    } else {
      setLoading(true);
      addPartner({ partnerName: partnerName })
        .then((res) => {
          setLoading(false);
          console.log(res, '[res]');
          if (res.body.message === 'success') {
            message.success(res.body.message);
          } else {
            message.error(res.body.errorMessage);
          }
          props.handleClose();
        })
        .catch((err) => {
          setLoading(false);
          message.error(err);
          console.error(err, '[err]');
        });
    }
    // props.handleClose();
  };

  return (
    <div>
      <Modal
        visible={props.modalIsOpen}
        title="Add New Partner For Center"
        onCancel={() => {
          props.handleClose();
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              props.handleClose();
            }}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleSubmit}
          >
            Submit
          </Button>,
        ]}
      >
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          //   initialValues={{ remember: true }}
          //   onFinish={this.onFinish}
          //   onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item label="Partner Name" name="partnerName">
            <Input value={partnerName} onChange={handleInputChange} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default AddPartnerModal;
